import { queryKeys } from "../queryKeys";
import { getDetails, type OwnerDetails } from "../rest/account";
import { useGetCurrentAccountIfLiveElseTradingAccount } from "./useGetAccount";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetOwnerDetails = ({
  accountID: requestedAccountID,
  options: queryOptions = {},
}: {
  accountID?: string;
  options?: QueryOptions<OwnerDetails>;
} = {}) => {
  const { account } = useGetCurrentAccountIfLiveElseTradingAccount();
  const accountID = requestedAccountID ?? account?.id ?? "";

  const { enabled = true, refetchInterval = false, ...rest } = queryOptions;
  const { data: details, ...resultRest } = useRequest(
    queryKeys.accounts.details(accountID),
    () => getDetails(accountID),
    {
      refetchInterval,
      enabled: enabled && !!accountID,
      ...rest,
    },
  );

  return { details, ...resultRest };
};

export default useGetOwnerDetails;
